module.exports = __webpack_public_path__ + "static/design_storelogo_pc_v2-52140c1741c8096a978f1aecd20fea10.png";